import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fddc9b62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CartMulti_TableContainer" }
const _hoisted_2 = { class: "CartMulti_TableWrap" }

import { ref } from "vue";
import BtnGreen from "../components/atoms/button/BtnGreen.vue";
import TableItem from "../components/TableItem.vue";
import TableShop from "../components/TableShop.vue";
import UploadFooter from "../components/UploadFooter.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import * as xlsx from "xlsx";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartMulti',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props) {

const props = __props;


//ぱんくずヘッダー
const currentPathList = [
  { name: "受注入力" },
  { name: "マルチ受注" },
  { name: "マルチカート照会" },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["CartMulti", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(TableShop)
        ])
      ])
    ])
  ], 2))
}
}

})